<template>
  <lk-modal
    :mask-closable="false"
    :closable="false"
    :footer-hide="true"
    v-model="val"
    width="800"
    @on-visible-change="handleVisible"
  >
    <p slot="header" class="modalHeader">
      <span class="mr8">撤销结算</span>
    </p>
    <div class="cardContent">
      <div class="infoTitle">
        <div class="title">购药方式：自主购药</div>
      </div>
      <div class="cardBaseInfo">
        <div class="cardLeft">
          <div class="cardType">卡类型:</div>
          <div>
            <lk-radio-group v-model="cardType">
              <lk-radio v-for="item in cardList" :key="item.id" :label="item.id">
                <span>{{ item.name }}</span>
              </lk-radio>
            </lk-radio-group>
          </div>
        </div>
        <div style="" class="cardRight" v-if="cardType === 2" >
          医保卡：
          <lk-input
            ref="QRcode"
            style="width:300px"
            v-model="QRcode"
          ></lk-input>
        </div>
        <lk-button
          type="primary"
          @click="handleClick"
          :disabled="cardStatus"
          :loading="btnCardLoading"
          >
          读卡
        </lk-button>
      </div>
      <div class="cardInfoArea">
        <div>
          <div v-for="(item, index) in cardInfo" :key="index" class="everyInfo">
            {{ `${item.title}：${cardInfoObj[item.pKey] ? cardInfoObj[item.pKey][item.key] : ""}` }}
          </div>
        </div>
      </div>
      <div class="btn-content">
        <!-- TODO: ljq 收费单据号待确认 -->
        <!-- <lk-form :label-width="90" :model="content" :rules="feeCodeValidate" ref="feeCode">
          <lk-form-item label="收费单据号:" prop="feeCode">
            <lk-input
                style="width:200px"
                placeholder="请输入收费单据号"
                v-model="feeCode">
              </lk-input>
            </lk-form-item>
        </lk-form> -->
        <lk-button
          type="primary"
          @click="handleRevocationClick"
          :loading="btnRefundLoading"
          :disabled='refundStatus'
          v-if="isLocal"
          >
          费用分解
        </lk-button>
      </div>
      <div class="cardInfoArea" v-if="isLocal">
        <div class="titleInfo">交易信息</div>
        <div class="everyInfoContent">
          <div v-for="(item, index) in dealInfo" :key="index" class="everyInfo">
            {{ `${item.title}:${dealInfoObj[item.key] ? dealInfoObj[item.key] : ""}` }}
          </div>
        </div>
        <div class="titleInfo">明细分解信息</div>
        <lk-table :columns="detailColumns" border :data="tableData"> </lk-table>
        <div class="titleInfo">汇总支付信息</div>
        <div class="everyInfoContent">
          <div v-for="(item, index) in sumPayInfo" :key="index" class="everyInfo">
            {{ `${item.title}:${sumPayInfoObj[item.key] || ""}` }}
          </div>
        </div>
        <div class="titleInfo">支付信息</div>
        <div class="everyInfoContent">
          <div v-for="(item, index) in payInfo" :key="index" class="everyInfo">
            {{ `${item.title}:${payInfoObj[item.key] || ""}` }}
          </div>
        </div>
      </div>
    </div>
    <div class="btnArea">
      <div class="btns">
        <lk-button @click="handleCancelClick">取消</lk-button>
        <lk-button
          type="primary"
          style="margin-right: 16px"
          @click="confirmClick"
          :disabled="confirmStatus"
          >确认撤销结算</lk-button
        >
      </div>
    </div>
  </lk-modal>
</template>

<script>
import _ from 'lodash';
import utils from '../../libs/utils';
import bjInsurance from '../../services/bjInsurance';


export default {
  name: 'BeijingInsPayModal',
  components: {
  },
  computed: {
    isLocal() {
      return this.cardInfoObj.icInfo && this.cardInfoObj.icInfo.cardClass == '1';
    },
  },
  watch: {
    value(value) {
      this.val = value;
    },
    cardType(val) {
      if (val === 2) {
        this.isElectronicInsurance = true;
        this.$nextTick(() => this.$refs.QRcode.focus());
      }
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    orderId: {
      default: null,
    },
    buymode: {
      type: Number,
      default: 1,
    },
    insuranceId: {
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      btnCardLoading: false,
      btnPreSetLoading: false,
      btnRefundLoading: false,
      ifBan: false,
      order: {},
      val: this.value,
      depositList: [],
      info: {},
      content: {
        insType: null,
        diseaseCode: null,
      },
      cardInfo: [
        {
          title: '社保卡卡号',
          key: 'cardNo',
          pKey: 'icInfo',
        },
        {
          title: '医保应用号',
          key: 'icNo',
          pKey: 'icInfo',
        },
        {
          title: '公民身份证号',
          key: 'idNo',
          pKey: 'icInfo',
        },
        {
          title: '姓名',
          key: 'personname',
          pKey: 'icInfo',
        },
        {
          title: '性别',
          key: 'sexName',
          pKey: 'icInfo',
        },
        {
          title: '出生日期',
          key: 'birthdayStr',
          pKey: 'icInfo',
        },
        {
          title: '转诊医院编码',
          key: 'fromhosp',
          pKey: 'icInfo',
        },
        {
          title: '转诊时限',
          key: 'fromhospdateStr',
          pKey: 'icInfo',
        },
        {
          title: '参保人员类别',
          key: 'personTypeName',
          pKey: 'net',
        },
        {
          title: '是否在红名单',
          key: 'isInredlistStr',
          pKey: 'net',
        },
        {
          title: '是否本人定点医院',
          key: 'isSpecifiedhospName',
          pKey: 'net',
        },
        {
          title: '是否本人慢病定点医院',
          key: 'ischronichospName',
          pKey: 'net',
        },
        {
          title: '个人账户余额',
          key: 'personcount',
          pKey: 'net',
        },
        {
          title: '慢病编码',
          key: 'chroniccode',
          pKey: 'net',
        },
        {
          title: '险种类型',
          key: 'fundtypeName',
          pKey: 'icInfo',
        },
        {
          title: '预提人员标识',
          key: 'isytName',
          pKey: 'icInfo',
        },
        {
          title: '军残等级',
          key: 'jclevelName',
          pKey: 'icInfo',
        },
        {
          title: '在院标识',
          key: 'hospflagName',
          pKey: 'icInfo',
        },
        {
          title: '民政救助标识',
          key: 'civilFlagName',
          pKey: 'icInfo',
        },
        {
          title: '人员类别',
          key: 'cardClassName',
          pKey: 'icInfo',
        },
      ],
      feeCode: null, // TODO: ljq 收费单据号项待确认
      feeCodeValidate: {
        feeCode: {
          required: true,
          message: '请输入收费单据号',
          trigger: 'change',
          type: 'string',
        },
      },
      dealInfo: [
        {
          title: '药店交易流水号',
          key: 'tradeno',
        },
        {
          title: '收费单据号',
          key: 'feeno',
        },
        {
          title: '交易时间日期',
          key: 'formatTradeDate',
        },
      ],
      detailColumns: [
        {
          title: '项目序号',
          key: 'itemno',
          width: 90,
        },
        {
          title: '处方序号',
          width: 90,
          key: 'recipeno',
        },
        {
          title: '药店系统项目代码',
          key: 'hiscode',
          width: 136,
        },
        {
          title: '医保项目代码',
          key: 'itemcode',
          width: 110,
        },
        {
          title: '医保项目名称',
          key: 'itemname',
          width: 110,
        },
        {
          title: '项目类别',
          key: 'itemTypeName',
          width: 90,
        },
        {
          title: '单价',
          key: 'unitprice',
          width: 70,
        },
        {
          title: '数量',
          key: 'count',
          width: 70,
        },
        {
          title: '项目总金额',
          key: 'fee',
          width: 110,
        },
        {
          title: '医保内总金额',
          key: 'feein',
          width: 110,
        },
        {
          title: '医保外总金额',
          key: 'feeout',
          width: 110,
        },
        {
          title: '个人自付2',
          key: 'selfpay2',
          width: 110,
        },
        {

          title: '分解状态',
          key: 'stateName',
          width: 90,
        },
        {
          title: '收费类别',
          key: 'feeTypeName',
          width: 90,
        },
        {
          title: '社区优惠金额',
          key: 'preferentialfee',
          width: 110,
        },
        {
          title: '社区优惠比例',
          key: 'preferentialscale',
          width: 110,
        },
        {
          title: '药品批准文号',
          key: 'approvalNumber',
          width: 110,
        },
        {
          title: '外配处方明细流水号',
          key: 'exRecipeDetailNo',
          width: 146,
        },
      ],
      sumPayInfo: [
        {
          title: '费用总金额',
          key: 'feeall',
        },
        {
          title: '基金支付金额',
          key: 'fund',
        },
        {
          title: '现金支付金额',
          key: 'cash',
        },
        {
          title: '个人账户支付金额',
          key: 'personcountpay',
        },
      ],
      payInfo: [
        {
          title: '费用总金额',
          key: 'fee',
        },
        {
          title: '医保内总金额',
          key: 'feein',
        },
        {
          title: '医保外总金额',
          key: 'feeout',
        },
        {
          title: '本次付起付线金额',
          key: 'payfirst',
        },
        {
          title: '个人自付2',
          key: 'selfpay2',
        },
        {
          title: '药店大额支付金额',
          key: 'bigpay',
        },
        {
          title: '药店大额自付金额',
          key: 'bigselfpay',
        },
        {
          title: '超大额自付金额',
          key: 'outofbig',
        },
        {
          title: '补充保险支付金额',
          key: 'bcpay',
        },
        {
          title: '军残补助保险',
          key: 'jcbz',
        },
        {
          title: '大病支付金额',
          key: 'bigIllPay',
        },
        {
          title: '民政救助支付金额',
          key: 'civilPay',
        },
      ],
      tableData: [],
      payInfoObj: {},
      sumPayInfoObj: {},
      dealInfoObj: {},
      cardInfoObj: {},
      insTypeList: [],
      insType: null,
      diseaseCode: null,
      refundStatus: true,
      confirmStatus: true,
      cardStatus: false,
      ids: {},
      cardType: 1, // 1、医保卡，2、电子就医凭证二维码
      cardList: [
        {
          id: 1,
          name: '医保卡',
        },
        {
          id: 2,
          name: '电子医保卡',
        },
      ],
      QRcode: '',
    };
  },
  methods: {
    handleVisible(val) {
      this.val = val;
      this.$emit('change', this.val);
      if (val) {
        this.cardType = 1;
        this.btnCardLoading = false;
        this.btnRefundLoading = false;
        this.cardStatus = false;
        this.refundStatus = true;
        this.confirmStatus = true;
        this.cardInfoObj = {};
        this.tableData = [];
        this.payInfoObj = {};
        this.sumPayInfoObj = {};
        this.dealInfoObj = {};
      }
    },
    handleClick() {
      this.handleReadCard();
    },
    handleReadCard() {
      this.btnCardLoading = true;
      const params = {
        buymode: this.buymode, // 1、自主购药， 2、外配处方购药 TODO：ljq 字段来源待确定
        multiclass: this.cardType,
        QRcode: this.QRcode,
      };
      bjInsurance.readCard(params)
        .then((res) => {
          this.btnCardLoading = false;
          if (res.data.status === 200) {
            this.$Message.success('读卡成功');
            this.cardInfoObj = res.data.data || {};
            this.btnCardLoading = false;
            this.refundStatus = false;
            if (!this.isLocal) {
              this.confirmStatus = false;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    // 撤销结算
    handleRevocationClick: _.debounce(function a() {
      this.btnRefundLoading = true;
      const params = {
        orderId: this.orderId,
      };
      bjInsurance.refundmentDivideDrugstore(params)
        .then((res) => {
          this.btnPreSetLoading = false;
          if (res.data.status === 200) {
            this.$Message.success('撤销成功');
            this.tableData = res.data.data.feeitemarray.feeitemarray;
            this.payInfoObj = res.data.data.payinfo;
            this.sumPayInfoObj = res.data.data.sumpay;
            this.dealInfoObj = res.data.data.tradeinfo;
            this.btnRefundLoading = false;
            this.confirmStatus = false;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    }, 500),
    confirmClick() {
      const params = {
        orderId: this.orderId,
        insuranceId: this.insuranceId,
      };
      bjInsurance.refundmentTradeDrugstore(params)
        .then((res) => {
          this.btnPreSetLoading = false;
          if (res.data.status === 200) {
            this.val = false;
            this.$emit('change', this.val);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleCancelClick() {
      this.val = false;
      this.$emit('change', this.val);
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.cardArea {
  height: 80px;
  display: flex;
  align-items: center;
  .cardRight {
    margin-left: 20px;
    display:flex;
    align-items:center
  }
}
.cardLeft {
  display: flex;
  .cardType {
    margin-right: 16px;
  }
}
.cardInfoArea {
  width: 100%;
  margin-bottom: 10px;
  background-color: #f1f5f8;
  padding: 10px 0 10px 24px;
  .everyInfo {
    display: inline-block;
    width: 33.3%;
    height: 30px;
    line-height: 30px;
  }
}
.btnArea {
  margin: 16px 0;
  .btns {
    display: flex;
    flex-direction: row-reverse;
  }
}
.red {
  color: red;
}

.payTitleInfo {
  color: #515a6e;
  font-size: 14px;
  font-weight: bold;
  height: 36px;
  line-height: 36px;
}
.titleInfo {
  font-size: 14px;
  font-weight: bold;
  color: #2d8cf0;
  height: 36px;
  line-height: 36px;
}
.POS-tips {
  padding-left: 20px;
  color: #808080;
  margin-bottom: 15px;
}
.cardContent {
  max-height: 480px;
  overflow: auto;
  .infoTitle {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px 10px;
    .ivu-form-item {
      margin-bottom: 0;
    }
  }
}
.cardBaseInfo {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px 10px;
  .ivu-form-item {
    margin-bottom: 0;
  }
}
.btn-content {
  display: flex;
  justify-content: flex-end;
  padding: 0 10px 10px 10px;
}
</style>
